import { render } from "./SetPassword.vue?vue&type=template&id=7086cb5a"
import script from "./SetPassword.vue?vue&type=script&lang=js"
export * from "./SetPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SetPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7086cb5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7086cb5a', __exports__)) {
    api.reload('7086cb5a', __exports__)
  }
  
  module.hot.accept("./SetPassword.vue?vue&type=template&id=7086cb5a", () => {
    api.rerender('7086cb5a', render)
  })

}


export default __exports__